import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable,take, throwError } from 'rxjs';
import { EnvironmentKeys } from 'src/environments/environment-keys';
import { ConfigService } from 'src/services/json-config.service';
import { IAccessToken } from 'src/models/auth.model';
import { getAppHeaders } from 'src/util/functions-angular';
import { DeviceService } from 'src/services/device.service';

@Injectable({ providedIn: 'root' })
export class AuthRestApiService {
  private http = inject(HttpClient);
  private configService = inject(ConfigService);
  private deviceService = inject(DeviceService);

  private getAppHeaders(accessToken: string) {
    return getAppHeaders({
      accept: 'application/json',
      accessToken: accessToken,
      isNativeApp: this.deviceService.isNativePlatform,
    })
  }

  // POST /api/v1/security/loginBCAS-mobile
  public backendLoginMobile(code: string, redirectUri: string): Observable<IAccessToken> {
    return this.http
    .post<IAccessToken>(
      this.configService.getConfig(EnvironmentKeys.apiUrl) + 'v1/security/loginBCAS-mobile',
      {
        code,
        redirectUri
      },
    )
    .pipe(
        take(1),
        catchError(this.handleError.bind(this)),
      );
  }

  // POST /api/v1/security/loginBCAS-web
  public backendLoginWeb(code: string, redirectUri: string): Observable<IAccessToken> {
    return this.http
    .post<IAccessToken>(
      this.configService.getConfig(EnvironmentKeys.apiUrl) + 'v1/security/loginBCAS-web',
      {
        code,
        redirectUri
      },
    )
    .pipe(
        take(1),
        catchError(this.handleError.bind(this)),
      );
  }

  // GET /api/v1/security/logout
  public logoutBackend(accessToken: string): Observable<{ idToken: string }> {
    return this.http
    .get<{ idToken: string }>(
      this.configService.getConfig(EnvironmentKeys.apiUrl) + 'v1/security/logout',
      {
        headers: this.getAppHeaders(accessToken),
      },
    ).pipe(take(1));
  }

  // POST /api/v1/security/refresh-web
  public refreshTokenWeb(refreshToken: string): Observable<IAccessToken> {
    return this.http
    .post<IAccessToken>(
      this.configService.getConfig(EnvironmentKeys.apiUrl) + 'v1/security/refresh-web',
      { refreshToken },
    )
    .pipe(
      take(1),
      catchError(this.handleError.bind(this)),
    );
  }

  // POST /api/v1/security/refresh
  public refreshTokenMobile(refreshToken: string): Observable<IAccessToken> {
    return this.http
    .post<IAccessToken>(
      this.configService.getConfig(EnvironmentKeys.apiUrl) + 'v1/security/refresh',
      { refreshToken },
    )
    .pipe(
      take(1),
      catchError(this.handleError.bind(this)),
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => error);
  }

}